import { css } from "@emotion/react";
import type React from "react";
import { CSS_MQ } from "../../../styles/breakpoints";

export const PDPAboveTheFoldLayoutWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <main css={mainStyles}>
      <div css={wrapperStyles}>{children}</div>
    </main>
  );
};

const mainStyles = css`
  ${CSS_MQ.atMostSm} {
    margin-top: 20px;
  }
`;

const wrapperStyles = css`
  --aspect-ratio: 4/5;
  ${CSS_MQ.atLeastMd} {
    --aspect-ratio: 1/1;
  }

  --mh: 0vh;

  max-width: var(--max-content-width-new);
  width: 100%;

  margin-left: auto;
  margin-right: auto;

  display: grid;
  grid-gap: 10px;
  grid-auto-flow: row;

  ${CSS_MQ.atLeastMd} {
    --mh: 75vh;
    display: grid;
    grid-gap: 30px;
    grid-template-rows: auto auto;

    grid-template-columns: minmax(0, 4fr) minmax(0, 5fr);
  }

  ${CSS_MQ.atLeastLg} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;
